import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';
import {Cliente} from '../../model/cliente.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {IonSlides} from '@ionic/angular';
import {DateService} from '../../services/date/date.service';
import {combineLatest} from 'rxjs';
import {take} from 'rxjs/operators';
import {LoadingService} from '../../services/loading/loading.service';
import {UtilsService} from '../../services/utils/utils.service';

@Component({
  selector: 'app-client-info-modal',
  templateUrl: './client-info-modal.component.html',
  styleUrls: ['./client-info-modal.component.scss'],
})
export class ClientInfoModalComponent implements OnInit {

  @Input() cliente: Cliente;
  @ViewChild('slider') slider: IonSlides;


  slideOpts = {
    initialSlide: 0,
    speed: 400,
    allowTouchMove: false,
  };

  genders = [
    'M', 'F'
  ];

  formGroup: FormGroup;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private _dateService: DateService,
    private _loadingService: LoadingService,
    private _utilsService: UtilsService,
  ) {
  }

  ngOnInit() {
    this.generateForm();
  }

  async nextSlide() {
    await this.slider.slideNext();
  }

  async prevSlide() {
    await this.slider.slidePrev();
  }

  get name() {
    return this.formGroup.get('name');
  }

  get surname() {
    return this.formGroup.get('surname');
  }

  get email() {
    return this.formGroup.get('email');
  }

  get birthDate() {
    return this.formGroup.get('birthDate');
  }

  get gender() {
    return this.formGroup.get('gender');
  }


  get dateInvalid() {
    const diff = +new Date() - this._dateService.fromIsoStringToMoment(this.birthDate.value).valueOf();
    return (diff / 31556926000) < 11;
  }

  get monthNames(): string[] {
    return this._dateService.monthNames;
  }

  get dayNames(): string[] {
    return this._dateService.dayNames;
  }

  get monthShortNames(): string[] {
    return this._dateService.monthShortNames;
  }

  updateUser() {
    const cliente: Cliente = this.cliente ?? {
      uid: this.authService.uid,
      phoneNumber: this.authService.pn
    };

    if (this.birthDate.valid) {
      const birthMoment = this._dateService.fromIsoStringToMoment(this.birthDate.value);
      const birthDate = birthMoment.toDate();

      const birthMonth = birthMoment.get('M') + 1;
      const birthDay = birthMoment.get('D');
      const birthYear = birthMoment.get('year');
      cliente.birthDate = birthDate;
      cliente.birthMonth = birthMonth;
      cliente.birthDay = birthDay;
      cliente.birthYear = birthYear;

      console.log(birthDate);
    }

    if (this.name.valid) {
      cliente.name = this.name.value?.toUpperCase();
    }

    if (this.surname.valid) {
      cliente.surname = this.surname.value?.toUpperCase();
    }

    if (this.email.valid) {
      cliente.email = this.email.value;
    }

    if (this.gender.valid) {
      cliente.gender = this.gender.value;
    }

    cliente.phoneNumber = this.authService.pn;
    cliente.uid = this.authService.uid;

    const arr = [
      this.authService.updateUser(cliente),
    ];
    combineLatest(arr).pipe(take(1))
      .subscribe(async res => {
        await this._loadingService.stopLoading();
        await this._utilsService.dismiss(null);
      }, async (err) => {
        await this._loadingService.stopLoading();
        await this._utilsService.presentToast('Errore salvataggio.');
      });
  }

  private generateForm() {
    this.formGroup = this.formBuilder.group({
      uid: [this.cliente?.uid],
      name: [this.cliente?.name, Validators.required],
      surname: [this.cliente?.surname, Validators.required],
      phoneNumber: [this.authService?.pn, Validators.required],
      email: [this.cliente?.email, [Validators.email, Validators.required]],
      gender: [this.cliente?.gender, Validators.required],
      birthDate: [this.cliente?.birthDate, Validators.required]
    });
  }

}
